<template>
  <div id="app">
    <router-view />
    <v-dialog style="z-index: 999999" />
    <notifications group="vera" />
    <loading-overlay v-show="requestCounter > 0" />
  </div>
</template>
<script>
import axios from "axios";
import LoadingOverlay from "@/components/LoadingOverlay";
export default {
  components: {
    LoadingOverlay,
  },
  data() {
    return {
      requestCounter: 0,
    };
  },
  mounted() {
    axios.interceptors.request.use((config) => {
      if (config.silent) return config;
      this.requestCounter++;
      return config;
    });
    axios.interceptors.response.use(
      (response) => {
        if (!(response.config && response.config.silent)) this.requestCounter--;
        return response;
      },
      (error) => {
        if (!(error.config && error.config.silent)) this.requestCounter--;
        return Promise.reject(error);
      }
    );
  },
};
</script>
<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
